import type { RowData } from '@tanstack/react-table';

import { useControllableState } from '../../../../core/hooks/useControllableState.js';
import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import type { DataTableOptions } from '../types/table.types.js';
import type { DataTableLineWrapProps } from './line-wrap-types.js';

/**
 * Configuration hook for the DataTable LineWrap feature.
 * @internal
 */
export function useColumnLineWrap<TData extends RowData>(
  props: DataTableLineWrapProps,
  options: DataTableOptions<TData>,
): void {
  const configLineWrap = useDataTableConfigElement('lineWrap');

  const [columnLineWrap, onColumnLineWrapChange] = useControllableState({
    value: props.lineWrap ?? configLineWrap,
    defaultValue: props.defaultLineWrap,
    onChange: props.onLineWrapChange,
  });

  // oxlint-disable-next-line react/immutability
  options.state = {
    ...options.state,
    columnLineWrap,
  };
  // oxlint-disable-next-line react/immutability
  options.onColumnLineWrapChange = onColumnLineWrapChange;
}
